<template>
  <div class="nav-header-content">
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-tabs ref="tabs" v-model="tabsName" type="card" @tab-click="handleTabClick" @tab-remove="handleTabRemove">
      <el-tab-pane label="首页" :raw="{path:'/'}" :closable="false" name="index"></el-tab-pane>
      <el-tab-pane closable :raw="item" :index="index" v-for="(item,index) in tabs" :key="index+''" :name="index+''">
        <span slot="label" @contextmenu.prevent="handleTabContextmenu(item,index)">{{item.meta.title||item.name}}</span>
      </el-tab-pane>
    </el-tabs>

    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="handleClose">关闭</v-contextmenu-item>
      <v-contextmenu-item @click="handleCloseOther">关闭其它</v-contextmenu-item>
      <v-contextmenu-item @click="handleCloseRight">关闭右边</v-contextmenu-item>
      <v-contextmenu-item @click="handleCloseAll">关闭全部</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabSize: 0
    };
  },
  created(){
    this.tabSize=this.tabs.length;
  },
  computed: {
    tabsName: {
      get() {
        return this.$store.state.app.tabsName;
      },
      set(val) { }
    },
    // 选项卡
    tabs() {
      return this.$store.state.app.tabs;
    }
  },
  watch: {
    // 监听选项卡变化
    tabs(val, oldVal) {
      // console.log(val,oldVal)
      //只处理tab关闭
      if (this.tabSize > val.length) {
        this.tabViewRemoveChange();
      }
      this.tabSize = val.length;
    }
  },
  methods: {
    //点击tab
    handleTabClick(tab) {
      if (tab.$attrs.raw) {
        //如果当前路由不等于tab 则跳到tab路由
        if (tab.$attrs.raw.fullPath != this.$route.fullPath) {
          this.$router.push(tab.$attrs.raw);
        }
      }
    },
    //关闭tab
    handleTabRemove(index) {
      this.$store.commit("splice", ["app.tabs", index]);
    },
    /**
     * 处理tab关闭，同步更新tab 视图
     */
    tabViewRemoveChange() {
      //如果当前路由等于tab
      var index = this.tabs.findIndex(route => {
        return route.fullPath == this.$route.fullPath;
      });
      if (index == -1) {
        var length = this.tabs.length;
        // tabs还有无tab
        if (length == 0) {
          this.$router.push("/");
        } else if (length == 1) {
          this.$router.push(this.tabs[0]);
          this.$store.commit("set", ["app.tabsName", "0"]);
        } else {
          this.$router.push(
            this.tabs[
            length < this.tabsName ? length - 1 : this.tabsName-1
            ]
          );
        }
      } else {
        this.$store.commit("set", ["app.tabsName", index + '']);
      }
    },
    /**
     * 选项卡右键菜单
     */
    handleTabContextmenu(raw, index) {
      this.$refs.contextmenu.hideAll();
      this.$refs.contextmenu.raw = raw;
      this.$refs.contextmenu.index = index;
      this.$refs.contextmenu.show({ top: event.clientY, left: event.clientX });
    },

    handleClose(vm, event) {
      var index = vm.$$contextmenu.index;
      this.handleTabRemove(index);
    },
    /**
     * 关闭其它
     */
    handleCloseRight(vm, event) {
      var index = vm.$$contextmenu.index;
      this.$store.commit("splice", ["app.tabs", index + 1, this.tabs.length - index - 1
      ]);
    },
    /**
     * 关闭其它
     */
    handleCloseAll(vm, event) {
      this.$store.commit("set", ["app.tabs", []]);
    },
    /**
     * 关闭其它
     */
    handleCloseOther(vm, event) {
      var index = vm.$$contextmenu.index;
      this.$store.commit("set", ["app.tabs", [this.tabs[index]]]);
    }
  }
};
</script>
<style>
.nav-header-content {
  box-sizing: border-box;
}
.nav-header-content .el-breadcrumb {
  padding: 10px 10px;
}
.nav-header-content .el-tabs__content {
  display: none;
}
.nav-header-content .el-tabs__header {
  margin: 0px;
}
.nav-header-content .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-left: 0px;
}
</style>